import { useAtom } from "jotai";
import { franchiseAtom } from "../atoms";

const useFranchiseHook = () => {
  const state = useAtom(franchiseAtom);
  return state;
};

export default useFranchiseHook;
